/*
 * @Author: edvardchen
 * @Date:   2016-12-26 17:00:04
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-01-28 13:24:56
 */

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
// import autobind from 'core-decorators/lib/autobind';

// import Loading  from '../components/Loading';
import {
  isIOS,
  // isAndroid,
  isQQBrowser,
  supportVideoSniff,
} from '../utility';
import { video } from '../fetchers';

const contextTypes = {
  sniff: PropTypes.func,
  playEpisode: PropTypes.func,
  canPlayEpisode: PropTypes.func,
  listenToVideoPlay: PropTypes.func,
  onVideoPlay: PropTypes.func,
};

const sniff = ({ vid, sharpness = 1, sPlayUrl }) => {
  const ua = window.navigator.userAgent;
  if (!isQQBrowser(ua) || supportVideoSniff(_.get(global, 'browser.env.version'))) {
    return video.sniff(vid);
  }

  // Android
  return new Promise((resolve, reject) => {
    const sniffHtml5Video = _.get(global, 'browser.video.sniffHtml5Video');
    if (!sniffHtml5Video) {
      reject('sniffHtml5Video not found');
      return;
    }
    sniffHtml5Video(sPlayUrl, sharpness, ({ status, urls }) => {
      const first = urls[0];
      if (status !== 0 || !first) {
        return reject(new Error('native sniff failed'));
      }
      resolve({
        url: first,
      });
    });
  });
};

const canPlayEpisode = () => {
  const ua = window.navigator.userAgent;
  return isQQBrowser(ua) && isIOS(ua) && supportVideoSniff(_.get(global, 'browser.env.version'));
};

const playEpisode = ({ vid, vSetNum = [], title, iType, sharpness = 1, sBarePlayUrl, sPlayUrl, sPageUrl, rect }) => {
  if (!canPlayEpisode()) {
    throw new Error('current enviroment not support playEpisode');
  }
  if (!vSetNum[0]) {
    throw new Error('video data error');
  }
  const options = {
    playType: 1,
    launchType: 3, // 1: TOPMOST, 2: FULLSCREEN, 3: INLINE
    numb: 1,
    playSetNumDirect: true,
    delay: 0,
    vType: iType,
    videoId: vid,
    src: vSetNum[0].iSrc,
    definition: sharpness, // window._NETWORK_TYPE_ === 'wifi' ? 1 : 0,
    videoTitle: title,
    pageUrl: sPageUrl,
    sourceUrl: sBarePlayUrl,
    webUrl: sPlayUrl,
    rect,
  };
  const handle = _.get(global, 'browser.video.playEpisode');
  handle && handle(options);
};

const listeners = [];
const getChildContext = () => ({
  sniff,
  playEpisode,
  canPlayEpisode,
  listenToVideoPlay: (fn) => {
    listeners.push(fn);
    const index = listeners.length;
    return {
      remove: () => {
        listeners.splice(index, 1);
      },
    };
  },
  onVideoPlay: (...args) => {
    listeners.forEach((item) => item(...args));
  },
});

export { contextTypes };

export default function withPlayContext(Wrapped) {
  // inject contextTypes
  Object.assign(Wrapped, {
    contextTypes: {
      ...contextTypes,
      ...Wrapped.contextTypes,
    },
  });

  class ContainerWithPlayContext extends React.Component {
    static propTypes = {
      // variables: PropTypes.object, // Transmit Container Component
      // userAgent: PropTypes.string,
    };

    static displayName = `${Wrapped.displayName || Wrapped.name}withPlayContext`;

    static childContextTypes = contextTypes;

    // constructor(props) {
    //   super(props);
    //   const { variables = {}, userAgent = '' } = props;
    //   this.state = {
    //     isIOS: isIOS(variables.userAgent || userAgent),
    //   };
    // }

    getChildContext = getChildContext;

    render() {
      return <Wrapped {...this.props} />;
    }
  }

  return ContainerWithPlayContext;
}
